import { Button } from '@malesia/react-components/dist/src/components/Button';
import { PageTitle } from '@malesia/react-components/dist/src/components/Page/Title';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { allAdminRoutePaths } from '../../../containers/Routes/allAdminRoutePaths';
import { managerListPermissions } from '../../../permissions/adminPages/user/managerList';
import { useUserPermissions } from '../../../permissions/useUserPermissions';

export const ManagerListHeaderWithStore: SFC = () => {
    const userPermissions = useUserPermissions();

    return (
        <PageTitle
            text={
                <FormattedMessage
                    id='front-app/ManagerListPage:Title'
                    defaultMessage='Managers'
                />
            }
            rightSlot={
                <Link to={allAdminRoutePaths.userManagerNew}>
                    <Button
                        icon='plus'
                        text={
                            <FormattedMessage
                                id='front-app/Agent/List:AddNewManager'
                                defaultMessage='Add new manager'
                            />
                        }
                    />
                </Link>
            }
            rightSlotHidden={!userPermissions.has(managerListPermissions.newManagerLink)}
        />
    );
};
